import React from "react";
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import AssetInputOrUploadSection from "./AssetInputOrUploadSection";
import { CREATIVE_NAMES, MOBILE_SIDECAR_CREATIVE_AD_FIELDS } from "./definitions";
import BaseCreativeControls from "./BaseCreativeControls";
import ColorPicker from "./ColorPicker";
import InputTextSection from "./InputTextSection";
import { InputSwitch } from "primereact/inputswitch";
import DropdownSection from "./DropdownSection";
import { InputText } from "primereact/inputtext";
const CREATIVE_TYPE = CREATIVE_NAMES.MOBILE_SIDECAR_CREATIVE;

const DIRECTIONALITY_OPTIONS = [
    { label: "Right side of screen", value: "rtl" },
    { label: "Left side of screen", value: "ltr" }
]

const SWITCH_SECTION_STYLES = css`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 0.5em;
    .label {
        font-weight: bold;
    }
`;

function GeneralSwitchSection({ label, isChecked, switchName, changeHandler, creativeType, children }) {
    return (
        <>
            <div css={SWITCH_SECTION_STYLES}>
                <span className="label">{label}</span>
                <InputSwitch
                    checked={isChecked}
                    name={switchName}
                    onChange={(e) => {
                        changeHandler(e, e.value, creativeType);
                    }}
                />
            </div>
            <div>{isChecked && children}</div>
        </>
    );
}

export default function MobileSidecarCreative({
    collapsedBanner,
    expandedBanner,
    handleChange,
    impressionTag,
    currentCustomer,
    adServingType,
    clickTag,
    ctaBgColor = '#ccc',
    ctaTextColor = '#000',
    ctaText = 'View More',
    enableInitialAnimation = false,
    dir = "rtl",
    topOffset = 0
}) {

    return (
        <>
            <BaseCreativeControls
                isClickTagRequired={true}
                adServingType={adServingType}
                changeHandler={handleChange}
                impressionTag={impressionTag}
                creativeType={CREATIVE_TYPE}
                renderClickUrlInput={true}
                clickTag={clickTag}
            >
                <GeneralSwitchSection
                    label="Enable initial 'shake' animation"
                    isChecked={!!enableInitialAnimation}
                    switchName="enableInitialAnimation"
                    changeHandler={handleChange}
                    creativeType={CREATIVE_TYPE}
                />

                <DropdownSection
                    adtype={CREATIVE_TYPE}
                    label="Creative placement"
                    name={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.dir}
                    changeHandler={handleChange}
                    value={dir}
                    options={DIRECTIONALITY_OPTIONS}
                />

                <AssetInputOrUploadSection
                    inputValue={collapsedBanner}
                    inputLabel="Small banner (150x250px)"
                    inputName={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.collapsedBanner}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />

                <AssetInputOrUploadSection
                    inputValue={expandedBanner}
                    inputLabel="Expanded banner (300x600px)"
                    inputName={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.expandedBanner}
                    inputChangeHandler={handleChange}
                    inputAdtype={CREATIVE_TYPE}
                    isRequired={true}
                    currentCustomer={currentCustomer}
                    accept="image/*"
                    defaultExtension="jpeg"
                />
                <InputTextSection
                    label="Top offset (px)"
                    name={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.topOffset}
                    value={topOffset}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    isNumericInput={true}
                />
                <InputTextSection
                    label="CTA Text"
                    name={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.ctaText}
                    value={ctaText}
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    uriEncodeValue={false}
                />
                <ColorPicker
                    label="CTA background color"
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    name={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.ctaBgColor}
                    value={ctaBgColor}
                />

                <ColorPicker
                    label="CTA text color"
                    changeHandler={handleChange}
                    adtype={CREATIVE_TYPE}
                    required={false}
                    name={MOBILE_SIDECAR_CREATIVE_AD_FIELDS.ctaTextColor}
                    value={ctaTextColor}
                />

            </BaseCreativeControls>
        </>
    );
}
